// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unused-vars */

import React, { FC, useState } from "react";
import { Button, Dimmer, Loader, Modal, Menu, Icon, Input } from "semantic-ui-react";
import { useUserAuth } from "../../../hooks/useUserAuth";
import { useModuleNavigation } from "../../../hooks/useModuleNavigation.js";
import Support from "../../Content/Support/index";
import _ from "lodash";

type Props = {
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const SupportModal: FC<Props> = ({ open, setOpen }) => {
	const userAuth = useUserAuth();
	const moduleNavigation = useModuleNavigation();
	const uri = (process.env.aerialPlotConnections as any).aerialPlotWeb.returnTo.split("/login")[0];

	const [loading, setLoading] = useState(true);
	const [step, setStep] = useState<"ticket" | "faq">("ticket");
	const [keywords, setKeywords] = useState("");

	const handleClose = () => {
		setOpen(false);
		setLoading(true);
		setStep("ticket");
	};

	return (
		<Modal open={open} style={{ width: "80%", maxHeight: "93%", overflowY: "auto" }}>
			<Modal.Header>
				<Icon
					name="close"
					size="mini"
					link
					onClick={() => handleClose()}
					style={{ padding: "6px 5px 5px 5px", height: "2.35em" }}
				/>
			</Modal.Header>
			<Modal.Content>
				<Menu pointing>
					<Menu.Item
						active={step === "ticket"}
						disabled={loading}
						onClick={() => setStep("ticket")}
						name="Feedback and Requests"
					>
						{/* <Step.Content>
							<Step.Title>Feedback and Requests</Step.Title>
						</Step.Content> */}
					</Menu.Item>

					<Menu.Item active={step === "faq"} disabled={loading} onClick={() => setStep("faq")} name="Support Videos">
						{/* <Step.Content>
							<Step.Title>Support Videos</Step.Title>
						</Step.Content> */}
					</Menu.Item>
					<Menu.Item position="right" disabled={loading || step !== "faq"}>
						<Input
							disabled={loading || step !== "faq"}
							icon="search"
							placeholder="Search..."
							onChange={(_, data) => setKeywords(data.value)}
						/>
					</Menu.Item>
				</Menu>
				<Dimmer inverted active={loading}>
					<Loader inverted />
				</Dimmer>
				{(() => {
					switch (step) {
						case "ticket":
							return (
								<iframe
									src={`https://forms.monday.com/forms/embed/40999dbfaf6f4bb27dba74b22ad12011?r=use1
												&email_mkktfdvw=${userAuth.user.userInfo.basic.emailAddress}
												&link_mkkty0qt=${uri + moduleNavigation.currentLocation}
												&link_mkktkccb=${uri + moduleNavigation.currentLocation}
											`}
									width={"100%"}
									style={{ border: 0, boxShadow: "5px 5px 56px 0px, rgba(0,0,0,0.25)", height: "71vh" }}
									onLoad={() => setLoading(false)}
								></iframe>
							);
						case "faq":
							return <Support origin={"modal"} updateSections={keywords} />;
					}
				})()}
			</Modal.Content>
			<Modal.Actions>
				<Button content="Close" onClick={() => handleClose()} />
			</Modal.Actions>
		</Modal>
	);
};

export default SupportModal;
